function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon_weight");

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 12,
  width: 42,
  height: 40,
  rx: 5.6,
  fill: "#e5daca",
  stroke: "#e5daca",
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M38,26.27c-4.61-1.88-7.37-1.88-12,0a1.18,1.18,0,0,1-1.42-.55c-1.27-2.26-1.91-3.38-3.19-5.63-.29-.53.1-1.26.89-1.58,7.47-3.05,12-3.05,19.42,0,.79.32,1.18,1,.89,1.58-1.28,2.25-1.92,3.37-3.19,5.63A1.18,1.18,0,0,1,38,26.27Z",
  fill: "#5cb3b1",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 46.5,
  y: 45.5,
  width: 3,
  height: 3,
  rx: 1,
  fill: "#5cb3b1"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 46.5,
  y: 15.5,
  width: 3,
  height: 3,
  rx: 1,
  fill: "#5cb3b1"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 14.5,
  y: 45.5,
  width: 3,
  height: 3,
  rx: 1,
  fill: "#5cb3b1"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 14.5,
  y: 15.5,
  width: 3,
  height: 3,
  rx: 1,
  fill: "#5cb3b1"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 31.5,
  y: 19,
  width: 1,
  height: 6,
  rx: 0.5
});

var SvgIconWeight = function SvgIconWeight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconWeight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-weight.13e52ed0.svg";
export { ForwardRef as ReactComponent };